const routes = [
  {
    path: 'no-cache',
    name: 'no-cache',
    component: () => import(/* webpackChunkName: "no-cache" */ '@/modules/no-cache/index.vue')
  },
];

export default routes;